<template>
    <div>
        <div class="tournament-detail-wrap">
            <component :is="whichStep"></component>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                type: this.$route.params.type
            }
        },
        components: {
            'ParticipantList': () => import('./detail/ParticipantList'),
            'TournamentLive': () => import('./detail/TournamentLive'),
            'TournamentTimeTable': () => import('./detail/TournamentTimeTable'),
            'TournamentFinalRanking': () => import('./detail/TournamentResult'),
        },
        computed: {
            whichStep(){
                switch(this.type){
                    case 'player':
                        return 'ParticipantList';

                    case 'figure':
                        return 'TournamentLive'

                    case 'timetable':
                        return 'TournamentTimeTable'
                    case 'ranking':
                        return 'TournamentFinalRanking'
                }
            }
        }
    }
</script>
